import React, { useContext } from 'react'
import { makeStyles } from '@material-ui/core'
import { useHistory, useLocation } from 'react-router-dom'
import clsx from 'clsx'
import SearchBoxCommon from '../components/SearchBoxCommon'
import { Context as PortfolioContext } from '../contexts/portfolio'
import logo from '../assets/images/logoBluefireAI.png'
import { PowerOff } from '../components/Icons'

const useStyles = makeStyles(() => ({
  root: {
    height: 64,
    padding: '12px 24px',
    backgroundColor: '#FFFFFF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid #E5E7EB',
    position: 'sticky',
    top: 0,
    zIndex: 110,
  },
  rootNotSticky: {
    position: 'static',
    top: 'auto',
    zIndex: 'auto',
  },
  brand: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 131,
    cursor: 'pointer',
  },
  brandLogo: {
    width: 131,
    height: 32,
    display: 'block',
  },
  search: {
    flex: '1 1 665px',
    width: 665,
    maxWidth: 665,
    margin: '0 24px',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 110,
    justifyContent: 'flex-end',
  },
  logoutButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    width: 95,
    height: 40,
    padding: '9px 12px',
    borderRadius: 3,
    border: '1px solid #1B39631A',
    backgroundColor: '#FFFFFF',
    color: '#1B3963',
    fontFamily: 'Inter, sans-serif',
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '22px',
    cursor: 'pointer',
    outline: 'none',
  },
  logoutIcon: {
    width: 16,
    height: 16,
    display: 'block',
  },
  '@media (max-width: 960px)': {
    root: {
      padding: '0 16px',
    },
    search: {
      margin: '0 12px',
      width: '100%',
      maxWidth: '100%',
    },
  },
}))

const TopBar = () => {
  const classes = useStyles()
  const history = useHistory()
  const location = useLocation()
  const { state } = useContext(PortfolioContext)
  const isCompanyPage = location.pathname.startsWith('/company')

  const onHandleLogout = () => {
    localStorage.clear()
    document.cookie.split(';').forEach(function (c) {
      document.cookie = c
        .replace(/^ +/, '')
        .replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`)
    })
    window.location.href = '/login'
  }

  const onGoHome = () => {
    history.push('/')
  }

  return (
    <div className={clsx(classes.root, isCompanyPage && classes.rootNotSticky)}>
      <div className={classes.brand} onClick={onGoHome}>
        <img src={logo} className={classes.brandLogo} alt="Blue Fire AI" />
      </div>
      <div className={classes.search}>
        <SearchBoxCommon
          placeholder="Search for company"
          searchList={state.tickersInUniverse || []}
        />
      </div>
      <div className={classes.actions}>
        <button
          type="button"
          className={classes.logoutButton}
          onClick={onHandleLogout}
        >
          <PowerOff
            size={16}
            color="#1B3963"
            opacity={1}
            className={classes.logoutIcon}
          />
          Logout
        </button>
      </div>
    </div>
  )
}

export default TopBar
